import ShopFilter from "$/components/ShopFilter";
import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

function FilterAccordion(props: {
  title?: string;
  items?: unknown;
  selected?: string;
  searchable?: boolean;
  onChange?: (val: unknown) => void;
  onSearch?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"));

  if (matchDownMd) {
    return (
      <ShopFilter
        title={props.title || ""}
        items={props.items}
        onChange={props.onChange}
        showFullList
        selected={props.selected}
      />
    );
  }

  return (
    <Accordion
      variant="outlined"
      disableGutters
      defaultExpanded={
        props.selected !== undefined && props.selected !== null && props.selected !== ""
      }
      sx={{
        border: "none",
        boxShadow: "none",
        "&.Mui-expanded::before": {
          opacity: 1,
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="subtitle3" color="primary">
          {props.title || ""}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {props.searchable && (
          <TextField
            id="outlined-basic"
            label={`Search ${props.title}`}
            variant="outlined"
            size="small"
            sx={{ mb: 1 }}
            onChange={props.onSearch}
            autoComplete="off"
          />
        )}
        <ShopFilter
          title={props.title || ""}
          items={props.items}
          onChange={props.onChange}
          showFullList
          selected={props.selected}
        />
      </AccordionDetails>
    </Accordion>
  );
}

export default FilterAccordion;
